/**
 * 회사 문서 플래그 정규화 — SPEC-CHINA-TESTFLAG-NORMALIZE-001 REQ-TF-001/002.
 *
 * 이 파일이 순수 함수로 분리된 이유: 정규화 로직을 컴포넌트 안에 두면
 * 단위 테스트가 CompanyFormModal → apis/chinaInapi → store 체인을 통째로
 * 끌어와 모듈 로드 시점에 실패한다. 판정 규칙만 격리해 외부 의존 0으로 둔다.
 */

/**
 * `companies.isTestCompany` 읽기 정규화.
 *
 * 운영 데이터에 4개 표현형이 공존한다 — boolean `true` / 문자열 `'Y'` /
 * 문자열 `'N'` / 필드 부재. 정규형은 boolean 이고 부재는 `false` 와 동치다.
 *
 * `value || false` 로는 부족하다: 문자열 `'N'` 도 truthy 라 그대로 통과하는데,
 * ant-design-vue 의 `a-switch` 는 `checked === checkedValue(기본 true)` 엄격
 * 비교라 문자열을 전부 OFF 로 그린다. 그 결과 테스트 회사(`'Y'`)가
 * "테스트 아님"으로 보이고, 저장하면 원값이 그대로 재영속된다.
 *
 * @param {unknown} value 회사 문서의 isTestCompany 원값
 * @returns {boolean}
 */
export function normalizeTestFlag(value) {
  return value === true || value === 'Y';
}
